import React from 'react';

import { useStaticQuery, graphql } from 'gatsby'

function AssessmentPlanList () {

    const data = useStaticQuery(graphql`
        query AssessmentPlanQuery {
            plans: allNodeAssessmentPlan(sort: {created: DESC}) {
            edges {
                node {
                title
                field_ap_notes {
                    processed
                }
                body {
                    processed
                }
                }
            }
            }
        }
    `);

    const plans = data.plans.edges;

    // Format rows
    let collection_rows = plans.map((element) => {
        return (
            <tr className="table-row">
                <td>{element.node.title}</td>
                <td dangerouslySetInnerHTML={{__html: element.node.body.processed}}></td>
                <td dangerouslySetInnerHTML={{__html: element.node.field_ap_notes.processed}}></td>
            </tr>
        )
    })

    return (<>
        <h2>Assessment Plans</h2>
        <table className="assessment-plans">
            <caption>A list of assessment projects</caption>
            <tr className="header">
                <th scope="col">Project Name</th>
                <th scope="col">Description and Purpose</th>
                <th scope="col">Date</th>
            </tr>
            {collection_rows}
        </table>
    </>);
       
}

export default AssessmentPlanList